import Price from '@allesauto/core/price';
import VehicleImage from '@allesauto/core/vehicleImage';
import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { ViewModes } from '@allesauto/utils/consts';
import { formatPrice } from '@allesauto/utils/funcs';
import React, { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

export interface CarConfiguratorPriceOfferProps {
  images?: SchemaTypes.VehicleImage[] | null;
  price: number;
  uvpPrice?: number;
  monthlyPrice?: number;
  modelName: string;
  make?: string;
}

const CarConfiguratorPriceOffer: FC<CarConfiguratorPriceOfferProps> = ({
  images,
  modelName,
  make,
  price,
  monthlyPrice,
  uvpPrice,
}) => {
  const intl = useIntl();

  const formatedUvpPrice = useMemo(
    () =>
      uvpPrice &&
      translate(intl, 'ui.PRICE.RECOMMENDED_PRICE', {
        price: formatPrice(intl, uvpPrice),
      }),
    [uvpPrice, intl]
  );

  const priceTextKey = 'ui.PRICE.PRICE_ONLY';

  const className = {
    containerClass:
      'sm:gap-10px grid sm:grid-cols-1 sm:mx-15px lg:gap-60px lg:grid-cols-2 lg:items-center lg:mx-60px lg:mt-40px sm:mt-20px',
    monthlyPriceClass: 'sm:text-grey100',
    mainPriceClass: 'sm:text-headline2',
    recommendedPriceClass:
      'sm:mb-5px lg:mb-10px text-grey40 line-through font-regular font-weight-normal text-p2',
  };

  return (
    <div className={className.containerClass}>
      {images?.length ? (
        <VehicleImage
          alt={`${make} ${modelName}`}
          filename={`${(images || [])[0]?.externalUrlLarge}`}
        />
      ) : (
        <VehicleImage filename={null} fallbackImage="pcp_pdp" />
      )}
      {!!price && (
        <div>
          {formatedUvpPrice && (
            <p className={className.recommendedPriceClass}>
              {formatedUvpPrice}
            </p>
          )}
          <Price
            price={price}
            displayView={ViewModes.GRID}
            priceTextKey={priceTextKey}
            monthlyPrice={monthlyPrice}
            isTeaserPrice={true}
            classNames={{
              monthlyPriceTextClass: className.monthlyPriceClass,
              monthlyPriceClass: className.monthlyPriceClass,
              mainPriceClass: className.mainPriceClass,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CarConfiguratorPriceOffer;
